export default "__VITE_ASSET__D95Q7_UY__"